/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const AnalyticsApp: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M11.4612 19.4222C11.5462 19.4222 11.6312 19.4202 11.7152 19.4182L12.2542 21.3082C11.9932 21.3312 11.7282 21.3422 11.4612 21.3422C6.46316 21.3422 2.41016 17.2902 2.41016 12.2912C2.41016 7.29223 6.46216 3.24023 11.4612 3.24023C16.4592 3.24023 20.5112 7.29223 20.5112 12.2912C20.5112 12.5722 20.4982 12.8492 20.4732 13.1232L18.5852 12.5852C18.5892 12.4872 18.5912 12.3892 18.5912 12.2912C18.5912 8.35324 15.3992 5.16023 11.4612 5.16023C7.52316 5.16023 4.33016 8.35224 4.33016 12.2912C4.33016 16.2292 7.52216 19.4222 11.4612 19.4222V19.4222ZM11.4612 8.78123C13.1392 8.78123 14.5422 9.95823 14.8892 11.5322L16.8882 12.1022C16.7882 9.19123 14.3972 6.86123 11.4612 6.86123C8.46216 6.86123 6.03116 9.29223 6.03116 12.2912C6.03116 15.2132 8.33816 17.5952 11.2302 17.7162L10.6582 15.7092C9.10616 15.3462 7.95116 13.9532 7.95116 12.2912C7.95116 10.3522 9.52316 8.78123 11.4612 8.78123V8.78123ZM12.0002 12.5052C11.7832 12.4432 11.5822 12.6442 11.6442 12.8612L13.9362 20.9062C14.1372 21.6102 15.0202 21.8402 15.5382 21.3222L20.4612 16.3992C20.9792 15.8812 20.7502 14.9982 20.0452 14.7972L12.0002 12.5052V12.5052ZM15.3352 18.8102L14.2942 15.1552L17.9492 16.1962L15.3362 18.8092L15.3352 18.8102Z" />

    </StyledIconBase>
  )
})

AnalyticsApp.displayName = 'AnalyticsApp'

export const AnalyticsAppDimensions = {height: 24, width: 24}
